import { useQuery } from '@tanstack/react-query';
import { useAPI } from '../Hooks/useAPIs';

export const useTableFilterOptions = (selectedItem, dateType) => {
  const { apiCall } = useAPI();

  const tableFilterOptionsQuery = useQuery({
    queryKey: ['table-filter-options', selectedItem?.vin, dateType],
    queryFn: async () => {
        if (!selectedItem?.vin || !selectedItem?.datetime) return null;
            const params = new URLSearchParams();
            params.append('vin', selectedItem.vin);
            if (dateType) {
              params.append('use_datetime_type', dateType);
            }
            const response = await apiCall('GET', `loggers/timeline/search?${params.toString()}`);
            return response;
    },
    enabled: Boolean(selectedItem?.vin),
  });
  return {
    tableFilterOptionsQuery,
    categories: tableFilterOptionsQuery?.data?.data.data.category || [],
    types: tableFilterOptionsQuery?.data?.data.data.file_type || [],
  };
};